import { render, staticRenderFns } from "./Venues.vue?vue&type=template&id=8c6f3ee2&scoped=true&"
import script from "./Venues.vue?vue&type=script&lang=js&"
export * from "./Venues.vue?vue&type=script&lang=js&"
import style0 from "./Venues.vue?vue&type=style&index=0&id=8c6f3ee2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6f3ee2",
  null
  
)

export default component.exports